import React from "react";
import ourServicesImg from './bg/OurServices.png';

export const OurServices = () => {
  return (
    <div 
      id="servicess" 
      className="container-fluid py-5" 
      style={{ backgroundColor: "#f8f9fa" }}
    >
      <div className="container">
        <h3 className="text-center mb-4" style={{ fontWeight: "bold" }}>
          Our Services
        </h3>
        
        <div className="row mb-5">
          <div className="col-12">
            <img 
              src={ourServicesImg} 
              alt="our services" 
              className="img-fluid"
              style={{ width: "100%", height: "auto" }} 
            />
          </div>
        </div>
      </div>
    </div>
  );
};
